import Cookies from 'js-cookie'
import { getTokenPayload } from './authSession'

export const STUDENT_ROLE_ID = 6
export const ADMIN_ROLE_ID = 1
export const PROFESSOR_ROLE_ID = 4
export const USER_ROLE_ID = 7
export const STUDENT_GROUP_NAME_AR = 'الطالب'

const getRoleIdFromToken = () => getTokenPayload()?.role_id ?? null

export const getStoredUser = () => {
  try {
    if (Cookies.get('user_data')) return JSON.parse(Cookies.get('user_data'))
    const storedUser = localStorage.getItem('userData')
    return storedUser ? JSON.parse(storedUser) : null
  } catch {
    return null
  }
}

export const getUserRoleId = (user = getStoredUser()) => {
  const roleFromUser = Number(user?.role_id)
  if (Number.isFinite(roleFromUser) && roleFromUser > 0) return roleFromUser

  const roleFromToken = Number(getRoleIdFromToken())
  return Number.isFinite(roleFromToken) && roleFromToken > 0 ? roleFromToken : null
}

export const isStudentUser = (user = getStoredUser()) => getUserRoleId(user) === STUDENT_ROLE_ID

export const isAdminUser = (user = getStoredUser()) => getUserRoleId(user) === ADMIN_ROLE_ID

export const isProfessorUser = (user = getStoredUser()) => getUserRoleId(user) === PROFESSOR_ROLE_ID
